<article *ngIf="exampleSJ"
         class="example-layout1">

  <div class="example-contents-box">

    <div class="example-contents-wrap">

      <a class="example-close-btn"
         (click)="onClose($event)"></a>

      <div *ngIf="!(ready$ | async) && exampleSJ.voiceExIdx !== null"
           class="example-not-ready-box">
        <div class="txt">
          소리 처리 모듈을 초기화를 하는 중입니다.<br/>
          잠시 기다리시면 자동으로 화면이 전환이 됩니다.
        </div>
        <div class="img-box"></div>

        <app-progress-bar [progress]="pbProgress"></app-progress-bar>
      </div>

      <div class="example-head-box">
        <app-example-disp [exampleSJ]="exampleSJ"></app-example-disp>

        <div class="option-box">

          <!-- TF model 로딩 중에는 재생 버튼은 숨기고 모래시계 표시 -->
          <div *ngIf="!(ready$ | async)"
               class="option-btn">
            <i class="ic ic-listen ing"></i>
          </div>

          <app-word-ex-play-btn *ngIf="ready$ | async"
                                [word]="word"
                                [exNum]="exampleSJ.voiceExIdx"
                                [large]="true"></app-word-ex-play-btn>
        </div>
      </div>


      <ng-container *ngIf="(ready$ | async) && exampleSJ.voiceExIdx !== null">
        <div class="example-body-box">
          <div class="example-view-box">
            <div class="view-con-box">

              <app-wav-graph class="wave_box"
                             [data]="data1"
                             [recorder]="recorderConfig || undefined">
              </app-wav-graph>
            </div>
          </div>


          <div class="example-view-box">
            <div class="view-tit-box">소리를 듣고 따라해 봅니다.<br/>녹음이 끝나면, 곧장 마이크를 다시 눌러야 종료가 됩니다.</div>
            <div class="view-con-box">

              <app-wav-graph class="wave_box"
                             [data]="data2"
                             [recorder]="userConfig">
              </app-wav-graph>
            </div>
          </div>
        </div>

        <div class="example-foot-box">

          <a class="example-foot-btn {{ btnRecordCss }}"
             (click)="onClickRecord($event)"></a>

          <app-pitch-help-btn></app-pitch-help-btn>

          <div class="reset-btn-box">
            <button type="button"
                    class="reset-btn"
                    (click)="OpenConfirmReset($event)">사용자 변경</button>
          </div>

        </div>

      </ng-container>

    </div>



  </div>
</article>
